import Swiper from 'swiper';

export default sliderPlaces => {
    // console.log('sliderPlaces');
    const swiperContainerProducts = sliderPlaces.querySelector('.swiper-container');
    const swiperPagination = sliderPlaces.querySelector('.swiper-pagination');

    const swiperButtonPrev = sliderPlaces.querySelector('.swiper-button-prev');
    const swiperButtonNext = sliderPlaces.querySelector('.swiper-button-next');

    const placessSlider = new Swiper(swiperContainerProducts, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        grabCursor: true,
        breakpoints: {
            576: {
            },
            768: {
            },
            992: {
                spaceBetween: 30,
            },
            1200: {
                spaceBetween: 30,
            },
            1370: {
                spaceBetween: 30,
            },
        },
        navigation: {

            nextEl: swiperButtonNext,
            prevEl: swiperButtonPrev,
        },
        pagination: {
            el: swiperPagination,
            clickable: true,
            renderBullet: (index, className) => `<button type="button" class="${className}"><span class="sr-only">${index + 1}</span></button>`,
        },
    });
};
